document.addEventListener('DOMContentLoaded', () => {

    const cover = document.getElementById('cover');
    
    //const init = () => {
        document.documentElement.removeAttribute('style');
        
        setTimeout(function() {
            document.documentElement.classList.add('is-loaded');
            inviewInit();
        }, 250)
        
        setTimeout(() => {
            window.anims();
            window.carousels();
            cover.remove();
        }, 500);  
    //};
    
    //window.addEventListener('load', init);

}, false);
